import {SET_PENDING_TRANSACTIONS} from 'constants/action-types.js';
import {SET_TRANSACTION_UPON_LOGIN} from 'constants/action-types.js';

let initialState = {
    pendingTransactions: [],
    transactionUponLogin: undefined
};
    
const transactionsReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_TRANSACTION_UPON_LOGIN:
        return {
            ... state,
            transactionUponLogin: action.payload
        };
    case SET_PENDING_TRANSACTIONS:
        return {
            ... state,
            pendingTransactions: action.payload
        };
    default:
        return state;
    }
};

export default transactionsReducer;
